import React, { Component, Fragment, Children } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import ModalForm from './ModalForm';
// import Table from './Table';

import './ParadigmaTableModal.scss';

/**
 * Renderiza una tabla con un modal para agregar información
 */
class ParadigmaTableModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            elementos: props.value || [],
            selectedRow: null
        }
    }

    static propTypes = {
        /** Una clase que se aplica al Modal */
        modalClassName: PropTypes.string,
        /** Título mostrado en los modales: Ejemplo: Agregar ${title} */
        title: PropTypes.string,
        /** Si es true, no permite modificar de ninguna forma la información recibida */
        disabled: PropTypes.bool,
        /** Arreglo de columnas que se renderizan como una tabla con la información ingresada */
        columns: PropTypes.arrayOf(
            PropTypes.shape({
                /** Propiedad name del input al que se hace referencia */
                name: PropTypes.string.isRequired,
                /** Valor por defecto a ser seteado en el estado del modal */
                defaultValue: PropTypes.any,
                /** Título de la columna */
                label: PropTypes.string.isRequired,
                /** Función que permite modificar la forma en que se renderiza la información
                 * en la tabla. Recibe como parámetro el valor del input y debe retornar el nuevo valor.
                 * (value: valor que se iba a mostrar en la tabla) =>
                 * newValue: valor que va a mostrarse en la tabla
                 */
                renderCell: PropTypes.func,
                /** Permite setear la anchura de la columna en cuestión */
                width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                /** Componente que se renderiza en el modal.
                 * Es una función que recibe cuatro parámetros:
                 *
                 * ( value: el valor guardado en el estado del modal
                 * onChange: la funcion que setea el nuevo valor en el estado del modal
                 * disabled: determina si el input debe mostrarse o no deshabilitado
                 * error: retorna un arreglo de errores compatible con ParadigmaAsyncSeeker
                 * ) => <Input />
                 */
                Input: PropTypes.func,
                /** Determina si el campo es o no requerido */
                required: PropTypes.bool,
                /** Una función que determina si el valor ingresado en el input es válido */
                validator: PropTypes.func,
                /** Mensaje que se muestra si el valor ingresado no cumple con la validación */
                errorMessage: PropTypes.string,
                /** Título separador que se muestra por encima del input.
                 * Si otros input poseen el mismo título separador se agrupan bajo el mismo */
                group: PropTypes.string,
                /** Esta propiedad determina el criterio utilizado para deshabilitar el input */
                disabled: PropTypes.func
            })
        ),
        /** Mensaje que se muestra cuando la tabla está vacía */
        emptyMessage: PropTypes.string,
        /** Arreglo de objetos que se renderizan en la tabla y se muestran
         * en los modales para verlos, editarlos o eliminarlos. */
        value: PropTypes.arrayOf(PropTypes.object),
        /** Arreglo de objectos que se renderizan en la tabla y no pueden modificarse */
        staticValue: PropTypes.arrayOf(PropTypes.object),
        /** Función que se ejecuta cada vez que se modifica el arreglo de elementos.
         * Recibe como parámetro el nuevo arreglo de elementos. */
        onChange: PropTypes.func,
        /** Función que se ejecuta como criterio para habilitar o deshabilitar las filas de la tabla.
         * Debe retornar true o false. */
        disabledRow: PropTypes.func,
        /** Arreglo de items con sus respectivos errores */
        error: PropTypes.array,
    }

    componentDidUpdate(prevProps) {
        const { value } = this.props;
        if (prevProps.value != value) {
            this.setState({ elementos: value });
        }
    }

    /** Agrega un nuevo elemento a la tabla */
    onSubmit = data => {
        const { onChange } = this.props;
        this.setState(
            prevState => ({
                elementos: prevState.elementos.concat(data)
            }),
            () => { if (onChange) onChange(this.state.elementos) }
        );
    }

    /** Elimina un elemento de la tabla */
    onDelete = row => {
        const { onChange } = this.props;
        this.setState(
            prevState => {
                prevState.elementos.splice(row, 1);
                return {
                    elementos: prevState.elementos,
                    selectedRow: null
                }
            },
            () => { if (onChange) onChange(this.state.elementos) }
        );
    }

    /** Edita un elemento de la tabla */
    onEdit = (row, data) => {
        const { onChange } = this.props;
        this.setState(
            prevState => {
                prevState.elementos[row] = {
                    ...prevState.elementos[row],
                    ...data,
                }
                return {
                    elementos: prevState.elementos,
                    selectedRow: null
                }
            },
            () => { if (onChange) onChange(this.state.elementos) }
        );
    }

    onSelectedRow = row => this.setState({ row });

    getError = array => {
        if (typeof array === 'object' && array.length > 0) {
            return array[0]['detail'];
        }
    }

    render() {
        const { elementos, selectedRow } = this.state;
        const { disabledRow, columns, disabled, emptyMessage, title, error } = this.props;
        const staticValue = this.props.staticValue || [];
        const tableColums = columns.filter(col => col.show);
        return (
            <Fragment>

                {
                    !disabled &&
                    <Fragment>

                        <ModalForm
                            action="create"
                            title={title}
                            onSubmit={this.onSubmit}
                            columns={columns}
                        />

                        <ModalForm
                            action="edit"
                            title={title}
                            onEdit={this.onEdit}
                            value={elementos[selectedRow]}
                            row={selectedRow}
                            columns={columns}
                        />

                        <ModalForm
                            action="delete"
                            title={title}
                            onDelete={this.onDelete}
                            value={elementos[selectedRow]}
                            row={selectedRow}
                            columns={columns}
                        />

                    </Fragment>
                }

                <ModalForm
                    action="detail"
                    title={title}
                    value={elementos[selectedRow]}
                    row={selectedRow}
                    columns={columns}
                />

                { tableColums &&
                    <Table size="sm" className="ptm__table">
                        <thead>
                            <tr>
                                { tableColums.map(column =>
                                    <th key={column.label} width={column.width}>
                                        {column.label}
                                    </th>
                                ) }
                            </tr>
                        </thead>

                        <tbody>
                            { staticValue.map((elem, i) =>
                                <tr className="bg-light" key={`static${i}`}>
                                    { tableColums.map((column, j) =>
                                        <td key={`static${i}${j}`}>
                                            {
                                                column.renderCell ?
                                                    column.renderCell(elem[column.name]) :
                                                    elem[column.name]
                                            }
                                        </td>
                                    ) }
                                </tr>
                            ) }
                            { elementos.map((elem, i) => {
                                const isRowDisabled = disabledRow ? disabledRow(elem) : false;
                                const err = error ? error() : null;
                                return (
                                    <tr
                                        key={`elem${i}`}
                                        onClick={
                                            isRowDisabled ?
                                            null :
                                            () => this.setState( prevState => ({
                                                selectedRow: (prevState.selectedRow !== i) ? i : null
                                            }))
                                        }
                                        className={
                                            (isRowDisabled ? '' : 'ptm__table-row ') +
                                            ((i === selectedRow) ? ' ptm__table-row--selected ' : '') +
                                            ((err && Object.keys(err[i]).length) ? 'text-danger' : '')
                                        }
                                    >
                                        { tableColums.map((column, j) => {
                                            // const err = error ? error() : null;
                                            const errMsg = (err && err[i]) ? this.getError(err[i][column.name]) : null;
                                            return (
                                                <td key={`${i}${j}`} className={errMsg ? 'text-danger' : ''}>
                                                    {
                                                        errMsg &&
                                                        <i className="fa fa-exclamation-circle mx-2"></i>
                                                    }
                                                    {
                                                        column.renderCell ?
                                                            column.renderCell(elem[column.name]) :
                                                            elem[column.name]
                                                    }
                                                    {   errMsg &&
                                                        <Fragment><br/><small>{errMsg}</small></Fragment>
                                                    }
                                                </td>
                                            );
                                        }
                                        ) }
                                    </tr>
                                )
                            }) }
                        { (elementos.length + staticValue.length) === 0 &&
                            <tr>
                                <td className="text-center" colSpan={tableColums.length >= 1 ? tableColums.length : 1}>
                                    {emptyMessage || 'No hay información.'}
                                </td>
                            </tr>
                        }
                        </tbody>
                    </Table>
                }
            </Fragment>
        );
    }
}

export default ParadigmaTableModal;



// WEBPACK FOOTER //
// ./src/components/ParadigmaTableModal/ParadigmaTableModal.js